import type { ReactElement } from 'react';
import Cart from 'models/Cart';
import Alert from '../Alert';

type Props = { cart: Cart; };

function MaximumSelectionAlert({ cart }: Props): ReactElement {
  return (
    <Alert type={cart?.alert?.type}>
      <span className="d-none d-sm-inline">
        You have reached the
        <strong>{' maximum amount of items '}</strong>
        allowed in your box.
      </span>
      <span className="d-sm-none">
        <strong>Max amount of items reached.</strong>
      </span>
    </Alert>
  );
}

export default MaximumSelectionAlert;
